import { render, staticRenderFns } from "./MarketSubstances.vue?vue&type=template&id=35b15c26"
import script from "./MarketSubstances.vue?vue&type=script&lang=js"
export * from "./MarketSubstances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports